import ISistemAlertRepositoryDataRepository from '../infractructure/repositories/iSistemAlertDataRepository';
import SistemAlertRepository from '../infractructure/repositories/sistemAlertDataRepository';
import { SistemAlertsData } from '../domain/SystemAlerts';

class GetSistemAlertDataService {
  private readonly _repository: ISistemAlertRepositoryDataRepository;

  constructor({
    repository
  }: {
    repository: ISistemAlertRepositoryDataRepository;
  }) {
    this._repository = repository;
  }

  execute({
    queryParams
  }: {
    queryParams: object;
  }): Promise<SistemAlertsData[]> {
    return this._repository
      .getSistemAlertData({ queryParams })
      .then((res) => res)
      .catch((error: any) => {
        // Si es 404, devolver lista vacía
        if (error?.message === 'Error: 404') {
          return [];
        }

        // Propagar otros errores
        throw error;
      });
  }
}

export default new GetSistemAlertDataService({
  repository: SistemAlertRepository
});

export { GetSistemAlertDataService };
